import axios from 'axios';
import { toTitleCase } from "../../helper";
import { theme } from "../../theme/theme";
import { SET_NOTIFICATION_ARRAY, SET_STEPPER_LABEL } from "../crumbs/crumbs.type";
import { DATA_ASSET_ACTIVE_TAB, LOAD_API_DATA, RESET_FORM_VALUE, SET_API_DATA, SET_DIMENSIONS, SET_DIMENSIONS_DATA, SET_FORM_OPTION } from "./dataAsset.type";
import axiosInstance from '../../axiosInstanceSetup';

export const setDataAssetActiveTab = (indexValue) => ({
    type: DATA_ASSET_ACTIVE_TAB,
    payload: {
        value: indexValue
    }
});
export const getADLSAccountList = () => {
    return async (dispatch, getState, { endpoint }) => {
        axiosInstance.get(`${endpoint}${process.env.REACT_APP_ADLS_ACCOUNT}`)
            .then(response => {
                // Handle success
                // if (response.data.status === "success") {
                dispatch({
                    type: SET_FORM_OPTION,
                    payload: {
                        formField: "adlsList",
                        data: response.data.adls_accounts
                    }
                })
                // }
            })
            .catch(error => {
                // Handle error
                console.error('Error:', error);
            });
    };
};
export const getADLSFileList = (account_name) => {
    return async (dispatch, getState, { endpoint }) => {
        dispatch({
            type: LOAD_API_DATA,
            payload: { apiField: "adlsDirectory" },
        });
        axiosInstance.get(`${endpoint}${process.env.REACT_APP_ADLS_FILE}?account_name=${account_name}`)
            .then(response => {
                // Handle success
                // if (response.data.status === "success") {
                dispatch({
                    type: SET_API_DATA,
                    payload: {
                        apiField: "adlsDirectory",
                        data: response.data,
                        status: "success",
                    },
                })
                let adlsFile = []
                Object.keys(response.data.adls_files).map((val) => {
                    if (val !== "sample_file/1FB774F0-C8D7-481E-96F7-D13ED46D3895") {
                        adlsFile.push({ name: val })
                    }


                })
                dispatch({
                    type: SET_FORM_OPTION,
                    payload: {
                        formField: "adlsDirectoryForm",
                        data: adlsFile
                    }
                })
                // }
            })
            .catch(error => {
                // Handle error
                console.error('Error:', error);
            });
    };
};
export const saveAndDoLater = (dataAssetId) => {
    return async (dispatch, getState, { endpoint }) => {
        const { dataAsset: { formData } } = getState();

        dispatch({
            type: LOAD_API_DATA,
            payload: { apiField: "recommendateRule" },
        });
        let cdeArray = []
        formData.cdeform.options.map((val) => {
            val.dimension.map((val1) => {
                cdeArray.push({
                    "data_asset_id": val.data_asset_id,
                    "dataframe_id": val.dataframe_id,
                    "check_name": val1.check_name,
                    "data_attribute_id": val.attribute_id,
                    "rule_name": val1.ruleName,
                    "rule_description": val1.rule_description,
                    "valid_values": val1.expression,
                    // "drift_percentage": 0,
                    // "drift_window_in_day": 0,
                    // "threshold": 0,
                    // "threshold_type": "string",
                    "created_by": val.created_by,
                    "last_modified_by": localStorage.getItem("userName"),
                    "end_date": val.end_date
                })
            })
        })
        axiosInstance.post(`${endpoint}${process.env.REACT_APP_SAVE_AND_DO_LATER}`,
            {

                "cdes": cdeArray

            })
            .then(response => {
                // Handle success

                if (response.data.status === "success") {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "recommendateRule",
                            data: response.data.message,
                            status: "success",

                        },
                    })

                } else {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "recommendateRule",
                            data: response.data.message,
                            status: response.data.status,

                        },
                    })
                }
                dispatch({
                    type: SET_FORM_OPTION,
                    payload: {
                        // TO DO: not sure about this
                        formField: "ruleRecommendationform",
                        data: []
                    }
                })
            })
            .catch(error => {
                // Handle error
                dispatch({
                    type: SET_API_DATA,
                    payload: {
                        apiField: "recommendateRule",
                        data: [],
                        status: "error",
                        message: "Process interrupt due to some technical issue."
                    },
                })
                console.error('Error:', error);
            });
    };
}
export const getdataAsset = (assetId) => {
    return async (dispatch, getState, { endpoint }) => {
        dispatch({
            type: LOAD_API_DATA,
            payload: { apiField: "assetSummary" },
        });
        // axios({
        //     method: 'get',
        //     url: `${endpoint}${process.env.REACT_APP_GET_ASSETS}${assetId}`,
        //     headers: {
        //       'Authorization': 'Bearer your-token',
        //       'Content-Type': 'application/json',
        //     },
        //     maxRedirects: 0, // Optional: Handle redirects manually if needed
        //   })
        axiosInstance.get(`${endpoint}${process.env.REACT_APP_GET_ASSETS}${assetId}`
            //   ,{
            //   params:{asset_id :dataAssetId}
            // }
        )
            .then(response => {
                // Handle success
                if (response.data.status === "success") {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "assetSummary",
                            data: {
                                ...response.data.data,
                                dataList: Object.keys(response.data.data.metrics).map((val) => {
                                    if (val === "quality_score") {
                                        return { title: `${toTitleCase(val)}`, value: `${response.data.data.metrics[val]}%`, color: response.data.data.metrics[val] > 95 ? theme.colors.success : response.data.data.metrics[val] < 91 ? theme.colors.fail : theme.colors.primary }
                                    }
                                    return { title: toTitleCase(val), value: response.data.data.metrics[val], color: theme.colors.primary }
                                }),
                                chartData: {
                                    title: "Quality Score Trend",
                                    chartType: "SimpleLine",
                                    display1: "displayFields",
                                    value1: "displayValue",
                                    // displayFields: ["2025-02-04", "2025-01-04", "2024-12-04", "2024-11-04", "2024-10-04", "2024-09-04", "2024-08-04", "2024-07-04", "2024-05-04"],
                                    // displayValue: [68.73, 68.73, 68.73, 68.73, 68.73, 68.73, 68.73, 68.73, 68.73]
                                    displayFields:
                                        // response.data.data.metrics.quality_score_trend.length === 0 ? ["2025-02-04", "2025-01-04", "2024-12-04", "2024-11-04", "2024-10-04", "2024-09-04", "2024-08-04", "2024-07-04", "2024-05-04"] :
                                        response.data.data.metrics.quality_score_trend.map((valc) => {
                                            return valc.execution_date
                                        }),
                                    //  ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
                                    displayValue:
                                        // response.data.data.metrics.quality_score_trend.length === 0 ? [68.73, 68.73, 68.73, 68.73, 68.73, 68.73, 68.73, 68.73, 68.73] : 
                                        response.data.data.metrics.quality_score_trend.map((valc) => {
                                            return valc.total_dq_score
                                        })
                                }
                            },
                            status: "success",
                        },
                    })
                    dispatch({
                        type: SET_FORM_OPTION,
                        payload: {
                            formField: "chartData",
                            data: {
                                title: "Quality Score Trend",
                                chartType: "SimpleLine",
                                display1: "displayFields",
                                value1: "displayValue",
                                displayFields: ["2025-02-04", "2025-01-04", "2024-12-04", "2024-11-04", "2024-10-04", "2024-09-04", "2024-08-04", "2024-07-04", "2024-05-04"],
                                displayValue: [68.73, 68.73, 68.73, 68.73, 68.73, 68.73, 68.73, 68.73, 68.73]
                            },
                            status: "success",
                        },
                    })
                    dispatch({
                        type: SET_STEPPER_LABEL,
                        payload: {
                            field: "dataAssetSteps",
                            id: 1,
                            value: response.data.data.data_asset_name
                        }
                    })
                }
            })
            .catch(error => {
                // Handle error
                console.error('Error:', error);
            });
    };
};

export const getConfigureDQAssetRule = (assetId) => {
    return async (dispatch, getState, { endpoint }) => {
        dispatch({
            type: LOAD_API_DATA,
            payload: { apiField: "configureAssetDQRule" },
        });
        axiosInstance.get(`${endpoint}${process.env.REACT_APP_CONFIGURE_ASSET_RULES}?asset_id=${assetId}`)
            .then(response => {
                // Handle success
                if (response.data.status === "success") {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "configureAssetDQRule",
                            data: response.data.asset_rules,
                            status: "success",
                        },
                    })
                    dispatch({
                        type: SET_FORM_OPTION,
                        payload: {
                            formField: "configureAssetDQRuleform",
                            data: response.data.asset_rules.map((value, index) => {
                                if (value.rule_details !== null) {
                                    return { rules_name: value.rule_name,driftValue: value.rule_details.drift_value, driftWindow: value.rule_details.drift_window, dataframe_id: value.dataframe_id, id: value.asset_rule_id, srNo: index + 1, dimension: value.dimension_name, check_name: value.check_name, rule_description: value.rule_description, threshold_type: value.rule_details.threshold_type, threshold_value: value.rule_details.threshold, is_active: value.is_active,drift_type:value.rule_details.drift_type,expression:value.sql_query }
                                } else {
                                    return { rules_name: null,driftValue:null, driftWindow: null, dataframe_id: value.dataframe_id, id: value.asset_rule_id, srNo: index + 1, dimension: value.dimension_name, check_name: value.check_name, rule_description: value.rule_description, threshold_type: null, threshold_value: null, is_active: value.is_active }

                                }
                            }),
                            status: "success",
                        },
                    })

                }
            })
            .catch(error => {
                // Handle error
                console.error('Error:', error);
            });
    };
};

export const getDQRuleHistory = (assetId) => {
    return async (dispatch, getState, { endpoint }) => {
        dispatch({
            type: LOAD_API_DATA,
            payload: { apiField: "dqRuleHistory" },
        });
        axiosInstance.get(`${endpoint}${process.env.REACT_APP_GET_COLUMN_LEVEL_RULE_HISTORY}?data_asset_id=${assetId}`)
            .then(response => {
                // Handle success
                if (response.data.status === "success") {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "dqRuleHistory",
                            data: response.data.rules,
                            status: "success",
                        },
                    })
                    dispatch({
                        type: SET_FORM_OPTION,
                        payload: {
                            formField: "dqRuleHistoryForm",
                            data: response.data.rules.map((value, index) => {
                                return { is_active: value.is_active, id: value.attribute_rule_id, column_name: value.attribute_name, dimension: value.dimension, rules_type: value.rules_type, rules_name: value.rule_name, rule_description: value.rule_description, dq_rule_check: value.check_name, threshold_type: value.threshold_type, threshold_value: value.threshold,expression:value.expression, modified_by: value.last_modified_by,modified_date:value.last_modified, date_time: value.created_date }
                            }
                            ),
                            status: "success",
                        },
                    })

                }
            })
            .catch(error => {
                // Handle error
                console.error('Error:', error);
            });
    };
};


export const getDQAssetRuleHistory = (assetId) => {
    return async (dispatch, getState, { endpoint }) => {
        dispatch({
            type: LOAD_API_DATA,
            payload: { apiField: "dqAssetRuleHistory" },
        });
        axiosInstance.get(`${endpoint}${process.env.REACT_APP_CONFIGURE_ASSET_RULES_HISTORY}?asset_id=${assetId}`)
            .then(response => {
                // Handle success
                if (response.data.status === "success") {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "dqAssetRuleHistory",
                            data: response.data.asset_rules,
                            status: "success",
                        },
                    })
                    dispatch({
                        type: SET_FORM_OPTION,
                        payload: {
                            formField: "dqRuleHistoryAssetForm",
                            data: response.data.asset_rules.map((value, index) => {
                                if (value.rule_details !== null) {
                                    return { rules_name: value.rule_name,driftValue: value.rule_details.drift_value, driftWindow: value.rule_details.drift_window, dataframe_id: value.dataframe_id, id: value.asset_rule_id, srNo: index + 1, dimension: value.dimension_name, check_name: value.check_name, rule_description: value.rule_description, threshold_type: value.rule_details.threshold_type, threshold_value: value.rule_details.threshold, is_active: value.is_active,drift_type:value.rule_details.drift_type,expression:value.sql_query,modified_by: value.last_modified_by,modified_date:value.last_modified }
                                } else {
                                    return { rules_name: null,driftValue:null, driftWindow: null, dataframe_id: value.dataframe_id, id: value.asset_rule_id, srNo: index + 1, dimension: value.dimension_name, check_name: value.check_name, rule_description: value.rule_description, threshold_type: null, threshold_value: null, is_active: value.is_active,drift_type:null,expression:null }

                                }
                            }),
                            status: "success",
                        },
                    })

                }
            })
            .catch(error => {
                // Handle error
                console.error('Error:', error);
            });
    };
};

export const getConfigureDQColumnRule = (assetId) => {
    return async (dispatch, getState, { endpoint }) => {
        dispatch({
            type: LOAD_API_DATA,
            payload: { apiField: "configureColumnDQRule" },
        });
        axiosInstance.get(`${endpoint}${process.env.REACT_APP_GET_COLUMN_LEVEL_RULE}?data_asset_id=${assetId}`)
            .then(response => {
                // Handle success
                if (response.data.status === "success") {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "configureColumnDQRule",
                            data: response.data.rules,
                            status: "success",
                        },
                    })
                    dispatch({
                        type: SET_FORM_OPTION,
                        payload: {
                            formField: "configureColumnDQRuleform",
                            data: response.data.rules
                            .map((value, index) => {
                                return { drift_type:value.drift_type,check_expression:value.check_expression,drift_percentage:value.drift_percentage,drift_value:value.drift_value,drift_window:value.drift_window_in_day, dimension: value.dimension, is_active: value.is_active, id: value.attribute_rule_id, column_name: value.attribute_name, dimension: value.dimension, rules_type: value.rules_type, rules_name: value.rule_name, rule_description: value.rule_description, dq_rule_check: value.check_name, threshold_type: value.threshold_type, threshold_value: value.threshold,expression:value.expression }
                            }
                            ),
                            status: "success",
                        },
                    })

                }
            })
            .catch(error => {
                // Handle error
                console.error('Error:', error);
            });
    };
};
export const deleteConfigureDqColumn = (attribute_id, assetId) => {
    return async (dispatch, getState, { endpoint }) => {

        axiosInstance.delete(`${endpoint}${process.env.REACT_APP_ATTRIBUTE_RULE}/${attribute_id}`)
            .then(response => {
                // Handle success
                dispatch(getConfigureDQColumnRule(assetId))
            })
            .catch(error => {
                // Handle error
                console.error('Error:', error);
            });
    };
}
export const deleteConfigureDqAsset = (assetRule_id, assetId) => {
    return async (dispatch, getState, { endpoint }) => {

        axiosInstance.delete(`${endpoint}${process.env.REACT_APP_CONFIGURE_ASSET_RULE}/${assetRule_id}`)
            .then(response => {
                // Handle success
                dispatch(getConfigureDQAssetRule(assetId))
            })
            .catch(error => {
                // Handle error
                console.error('Error:', error);
            });
    };
}
export const ruleRecommendation = (dataAssetId) => {
    return async (dispatch, getState, { endpoint }) => {
        dispatch({
            type: LOAD_API_DATA,
            payload: { apiField: "recommendateRule" },
        });
        // if (showLoadingMessage !== undefined) {
        //     showLoadingMessage()
        // }
        axiosInstance.get(`${endpoint}${process.env.REACT_APP_API_RULE_RECOMMEND}`
            , {
                params: { asset_id: dataAssetId }
            }
        )
            .then(response => {
                // Handle success
                if (response.data.status === "success") {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "recommendateRule",
                            data: response.data.data,
                            status: "success",
                        },
                    })

                }
                // if (show !== undefined) {
                //     show()
                // }

            })
            .catch(error => {
                // Handle error
                console.error('Error:', error);
            });
    };
};
export const getSampleData = (assetId) => {
    return async (dispatch, getState, { endpoint }) => {
        dispatch({
            type: LOAD_API_DATA,
            payload: { apiField: "sampleData" },
        });
        axiosInstance.get(`${endpoint}${process.env.REACT_APP_GET_SAMPLE_DATA}${assetId}`
            //   ,{
            //   params:{asset_id :dataAssetId}
            // }
        )
            .then(response => {
                // Handle success
                if (response.data.status === "success") {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "sampleData",
                            data: response.data.sample_data,
                            status: "success",
                        },
                    })

                } else {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "sampleData",
                            data: [],
                            status: response.data.data.status,
                        },
                    })
                }
            })
            .catch(error => {
                // Handle error
                console.error('Error:', error);
                dispatch({
                    type: SET_API_DATA,
                    payload: {
                        apiField: "sampleData",
                        data: [],
                        status: "fail",
                    },
                })
            });
    };
};

export const getCheckNames = (assetId) => {
    return async (dispatch, getState, { endpoint }) => {
        // dispatch({
        //     type: LOAD_API_DATA,
        //     payload: { apiField: "check_type" },
        // });
        axiosInstance.get(`${endpoint}${process.env.REACT_APP_CHECK_NAME}`
            //   ,{
            //   params:{asset_id :dataAssetId}
            // }
        )
            .then(response => {
                // Handle success
                if (response.data.status === "success") {
                    dispatch({
                        type: SET_FORM_OPTION,
                        payload: {
                            formField: "check_type",
                            data: response.data.check_names,
                            status: "success",
                        },
                    })

                } else {
                    dispatch({
                        type: SET_FORM_OPTION,
                        payload: {
                            apiField: "check_type",
                            data: [],
                            status: response.data.status,
                        },
                    })
                }
            })
            .catch(error => {
                // Handle error
                console.error('Error:', error);
                dispatch({
                    type: SET_FORM_OPTION,
                    payload: {
                        apiField: "dimension",
                        data: [],
                        status: "fail",
                    },
                })
            });
    };
};

export const getDimensionNames = (assetId) => {
    return async (dispatch, getState, { endpoint }) => {
        axiosInstance.get(`${endpoint}${process.env.REACT_APP_DIMENSION}`)
            .then(response => {
                // Handle success
                if (response.data.status === "success") {
                    dispatch({
                        type: SET_FORM_OPTION,
                        payload: {
                            formField: "dimension",
                            data: response.data.dimensions,
                            status: "success",
                        },
                    })
                    dispatch(getDimensionsWeightage(assetId))
                } else {
                    dispatch({
                        type: SET_FORM_OPTION,
                        payload: {
                            apiField: "dimension",
                            data: [],
                            status: response.data.status,
                        },
                    })
                }
            })
            .catch(error => {
                // Handle error
                console.error('Error:', error);
                dispatch({
                    type: SET_FORM_OPTION,
                    payload: {
                        apiField: "dimension",
                        data: [],
                        status: "fail",
                    },
                })
            });
    };
};


export const getCDEDimensionNames = (attributeID) => {
    return async (dispatch, getState, { endpoint }) => {
        axiosInstance.get(`${endpoint}${process.env.REACT_APP_DIMENSION}`)
            .then(response => {
                // Handle success
                if (response.data.status === "success") {
                    dispatch({
                        type: SET_FORM_OPTION,
                        payload: {
                            formField: "cdeDimension",
                            data: response.data.dimensions.map((val) => {
                                return { attributeId: attributeID, ...val }
                            }),
                            status: "success",
                        },
                    })

                } else {
                    dispatch({
                        type: SET_FORM_OPTION,
                        payload: {
                            apiField: "dimension",
                            data: [],
                            status: response.data.status,
                        },
                    })
                }
            })
            .catch(error => {
                // Handle error
                console.error('Error:', error);
                dispatch({
                    type: SET_FORM_OPTION,
                    payload: {
                        apiField: "dimension",
                        data: [],
                        status: "fail",
                    },
                })
            });
    };
};

export const getColumnsNames = (assetId) => {
    return async (dispatch, getState, { endpoint }) => {
        // dispatch({
        //     type: LOAD_API_DATA,
        //     payload: { apiField: "check_type" },
        // });
        axiosInstance.get(`${endpoint}${process.env.REACT_APP_GET_COLUMNS}/${assetId}`
            //   ,{
            //   params:{asset_id :dataAssetId}
            // }
        )
            .then(response => {
                // Handle success
                if (response.data.status === "success") {
                    dispatch({
                        type: SET_FORM_OPTION,
                        payload: {
                            formField: "addColumns",
                            data: response.data.columns,
                            status: "success",
                        },
                    })

                } else {
                    dispatch({
                        type: SET_FORM_OPTION,
                        payload: {
                            formField: "addColumns",
                            data: [],
                            status: response.data.status,
                        },
                    })
                }
            })
            .catch(error => {
                // Handle error
                console.error('Error:', error);
                dispatch({
                    type: SET_FORM_OPTION,
                    payload: {
                        formField: "addColumns",
                        data: [],
                        status: "fail",
                    },
                })
            });
    };
};
export const getDQHistoryNames = (assetId) => {
    return async (dispatch, getState, { endpoint }) => {
        // dispatch({
        //     type: LOAD_API_DATA,
        //     payload: { apiField: "check_type" },
        // });
        axiosInstance.get(`${endpoint}${process.env.REACT_APP_API_DQRULES}/${assetId}`
            //   ,{
            //   params:{asset_id :dataAssetId}
            // }
        )
            .then(response => {
                // Handle success
                if (response.data.status === "success") {
                    dispatch({
                        type: SET_FORM_OPTION,
                        payload: {
                            formField: "dqRuleHistory",
                            data: response.data.dimensions,
                            status: "success",
                        },
                    })

                } else {
                    dispatch({
                        type: SET_FORM_OPTION,
                        payload: {
                            apiField: "dqRuleHistory",
                            data: [],
                            status: response.data.status,
                        },
                    })
                }
            })
            .catch(error => {
                // Handle error
                console.error('Error:', error);
                dispatch({
                    type: SET_FORM_OPTION,
                    payload: {
                        apiField: "dqRuleHistory",
                        data: [],
                        status: "fail",
                    },
                })
            });
    };
};
export const getdataAssetProfile = (assetId) => {
    return async (dispatch, getState, { endpoint }) => {
        dispatch({
            type: LOAD_API_DATA,
            payload: { apiField: "profileCde" },
        });
        axiosInstance.get(`${endpoint}${process.env.REACT_APP_API_GET_PROFILING}${assetId}`
            //   ,{
            //   params:{asset_id :dataAssetId}
            // }
        )
            .then(response => {
                // Handle success
                // if (response.data.status === "success") {
                dispatch({
                    type: SET_API_DATA,
                    payload: {
                        apiField: "profileCde",
                        data: response.data.data.attribute_metadata.map((val) => {
                            return { ...val, attribute_details: JSON.parse(val.attribute_details) }
                        }),
                        status: "success",
                    },
                })

                // }
            })
            .catch(error => {
                // Handle error
                console.error('Error:', error);
            });
    };
};

export const addTags = (formtags,assetId) => {
    return async (dispatch, getState, { endpoint }) => {
        dispatch({
            type: LOAD_API_DATA,
            payload: { apiField: "addedTag" },
        });
        console.log(formtags)
        axiosInstance.put(`${endpoint}${process.env.REACT_APP_TAG_UPDATE}?data_asset_id=${assetId}&tags=${formtags.join(", ")}` )
            .then(response => {
                // Handle success

                if (response.data.status === "success") {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "addedTag",
                            data: response.data.message,
                            status: "success",

                        },
                    })

                } else {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "addedTag",
                            data: response.data.message,
                            status: response.data.status,

                        },
                    })
                }
                dispatch({
                    type: RESET_FORM_VALUE
                })
                dispatch(getdataAsset(assetId))
            })
            .catch(error => {
                // Handle error
                dispatch({
                    type: SET_API_DATA,
                    payload: {
                        apiField: "configureColumnDQRule",
                        data: [],
                        status: "error",
                        message: "Process interrupt due to some technical issue."
                    },
                })
                console.error('Error:', error);
            });

    };
};
export const addNewColumnLevelRule = (assetId) => {
    return async (dispatch, getState, { endpoint }) => {
        const { dataAsset: { formData } } = getState();

        dispatch({
            type: LOAD_API_DATA,
            payload: { apiField: "configureColumnDQRule" },
        });
        axiosInstance.post(`${endpoint}${process.env.REACT_APP_ATTRIBUTE_RULE}`,
            {
                "data_asset_id": assetId,
                // "dataframe_id": "string",
                "check_expression":formData.dataAssetChecks.value,
                "check_id": formData.check_type.valueAsObj.check_id,
                "data_attribute_id": formData.addColumns.valueAsObj.attribute_id,
                "rule_name": formData.ruleName.value,
                "rule_description": formData.ruleDescription.value,
                "expression": formData.validValues.value,
                "drift_type":formData.drift_type.value,
                // "drift_percentage": formData.driftPercentage.value === "" ? null : formData.driftPercentage.value,
                "drift_window_in_day": formData.driftWindow.value,
                "threshold": formData.threshold.value,
                "threshold_type": formData.threshold_type.value,
                "dimension": formData.dimension.valueAsObj.id,
                "is_active": true,
                "drift_value": formData.drift_type.value == null?null:( formData.drift_type.value === "Percentage" ? JSON.stringify(formData.driftPercentage.value) : JSON.stringify(formData.driftValue.value)),
                "created_by": localStorage.getItem("userId"),
                "last_modified_by": localStorage.getItem("userId"),
                "end_date": new Date()
            })
            .then(response => {
                // Handle success
                let tempArray = JSON.parse(sessionStorage.getItem('bellNotification'));
                tempArray.push(response.data.message)
                sessionStorage.setItem('bellNotification', JSON.stringify(tempArray));
                dispatch({
                    type:SET_NOTIFICATION_ARRAY,
                    payload:{
                        value:tempArray
                    }
                })
                if (response.data.status === "success") {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "configureColumnDQRule",
                            data: response.data.message,
                            status: "success",

                        },
                    })

                } else {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "configureColumnDQRule",
                            data: response.data.message,
                            status: response.data.status,

                        },
                    })
                }
                dispatch(getConfigureDQColumnRule(assetId))
                dispatch({
                    type: RESET_FORM_VALUE
                })
            })
            .catch(error => {
                // Handle error
                dispatch({
                    type: SET_API_DATA,
                    payload: {
                        apiField: "configureColumnDQRule",
                        data: [],
                        status: "error",
                        message: "Process interrupt due to some technical issue."
                    },
                })
                console.error('Error:', error);
            });
    };
};


export const addNewAssetLevelRule = (assetId) => {
    return async (dispatch, getState, { endpoint }) => {
        const { dataAsset: { formData } } = getState();

        dispatch({
            type: LOAD_API_DATA,
            payload: { apiField: "configureAssetDQRule" },
        });
        axiosInstance.post(`${endpoint}${process.env.REACT_APP_CONFIGURE_ASSET_RULE}`,
            {
                "data_asset_id": assetId,
                "check_id": formData.check_type.valueAsObj.check_id,
                "rule_details": {
                    // "drift": formData.driftValue.value,
                    "drift_window": formData.driftWindow.value,
                    "threshold": formData.threshold.value,
                    "threshold_type": formData.threshold_type.value,
                    "drift_type":formData.drift_type.value,
                    "drift_value":formData.drift_type.value==='Percentage'?formData.driftPercentage.value:formData.driftValue.value,

                    
                },
                "sql_query": formData.expression.value,
                "rule_name": formData.ruleName.value,
                "rule_description": formData.ruleDescription.value,
                "is_active": true,
                "created_by": localStorage.getItem("userName"),
                "last_modified_by": localStorage.getItem("userName"),
                "end_date": new Date()
            }
        )
            .then(response => {
                // Handle success
                let tempArray = JSON.parse(sessionStorage.getItem('bellNotification'));
                tempArray.push(response.data.message)
                sessionStorage.setItem('bellNotification', JSON.stringify(tempArray));
                dispatch({
                    type:SET_NOTIFICATION_ARRAY,
                    payload:{
                        value:tempArray
                    }
                })
                if (response.data.status === "success") {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "configureAssetDQRule",
                            data: response.data.message,
                            status: "success",

                        },
                    })

                } else {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "configureAssetDQRule",
                            data: response.data.message,
                            status: response.data.status,

                        },
                    })
                }
                dispatch(getConfigureDQAssetRule(assetId))
                dispatch({
                    type: RESET_FORM_VALUE
                })
            })
            .catch(error => {
                // Handle error
                dispatch({
                    type: SET_API_DATA,
                    payload: {
                        apiField: "configureAssetDQRule",
                        data: [],
                        status: "error",
                        message: "Process interrupt due to some technical issue."
                    },
                })
                console.error('Error:', error);
            });
    };
};
export const getSelectedCDE = (assetId) => {
    return async (dispatch, getState, { endpoint }) => {
        const { dataAsset: { formData } } = getState();

        dispatch({
            type: LOAD_API_DATA,
            payload: { apiField: "cde" },
        });
        axiosInstance.get(`${endpoint}${process.env.REACT_APP_SHOW_CDE}?data_asset_id=${assetId}`)
            .then(response => {
                // Handle success

                if (response.data.status === "success") {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "cde",
                            data: response.data.cdes,
                            status: "success",

                        },
                    })
                    dispatch({
                        type: SET_FORM_OPTION,
                        payload: {
                            formField: "cdeform",
                            data: response.data.cdes.map((val) => {
                                return { ...val, dimension: [] }
                            }),
                            status: "success",

                        },
                    })
                } else {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "cde",
                            data: [],
                            status: response.data.status,

                        },
                    })
                }
                // dispatch(getConfigureDQColumnRule(assetId))
                // dispatch({
                //     type: RESET_FORM_VALUE
                // })
            })
            .catch(error => {
                // Handle error
                dispatch({
                    type: SET_API_DATA,
                    payload: {
                        apiField: "recommendateRule",
                        data: [],
                        status: "error",
                        message: "Process interrupt due to some technical issue."
                    },
                })
                console.error('Error:', error);
            });
    };
}
export const submitTempRuleRecommendation = (assetId) => {
    return async (dispatch, getState, { endpoint }) => {
        const { dataAsset: { formData } } = getState();

        dispatch({
            type: LOAD_API_DATA,
            payload: { apiField: "recommendateRule" },
        });
        const updatedArray = formData.ruleRecommendationform.options.map(item => {
            // Create a new object with the new key and copy the other properties
            const { attribute_id, ...rest } = item;
            return { data_attribute_id: attribute_id, ...rest, created_by: localStorage.getItem("userName"), last_modified_by: localStorage.getItem("userName") };
        });
        axiosInstance.post(`${endpoint}${process.env.REACT_APP_GET_ATTRIBUTE_BULK_API}`,
            {
                "rules": updatedArray
            }
            // {
            //     "data_asset_id": formData.ruleRecommendationform.options[0].data_asset_id,
            //     "dataframe_id": formData.ruleRecommendationform.options[0].dataframe_id,
            //     "check_id": formData.ruleRecommendationform.options[0].check_id,
            //     "data_attribute_id": formData.ruleRecommendationform.options[0].attribute_id,
            //     "rule_name": formData.ruleRecommendationform.options[0].rule_name,
            //     "rule_description": formData.ruleRecommendationform.options[0].rule_description,
            //     "dimension": formData.ruleRecommendationform.options[0].dimension_name,
            //     "is_active": formData.ruleRecommendationform.options[0].is_active,
            //     "created_by": formData.ruleRecommendationform.options[0].created_by,
            //     "last_modified_by": formData.ruleRecommendationform.options[0].last_modified_by,
            //     "end_date": formData.ruleRecommendationform.options[0].end_date
            // }
        )
            .then(response => {
                // Handle success

                if (response.data.status === "success") {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "recommendateRule",
                            data: response.data.message,
                            status: "success",

                        },
                    })
                    dispatch(getConfigureDQColumnRule(assetId))
                } else {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "recommendateRule",
                            data: response.data.message,
                            status: response.data.status,

                        },
                    })
                }
                dispatch({
                    type: SET_FORM_OPTION,
                    payload: {
                        // TO DO: not sure about this
                        formField: "ruleRecommendationform",
                        data: []
                    }
                })
            })
            .catch(error => {
                // Handle error
                dispatch({
                    type: SET_API_DATA,
                    payload: {
                        apiField: "recommendateRule",
                        data: [],
                        status: "error",
                        message: "Process interrupt due to some technical issue."
                    },
                })
                console.error('Error:', error);
            });
    };
}
export const submitTempCDESelection = (assetId) => {
    return async (dispatch, getState, { endpoint }) => {
        const { dataAsset: { formData } } = getState();

        dispatch({
            type: LOAD_API_DATA,
            payload: { apiField: "recommendateRule" },
        });
        let cdeArray = []
        formData.cdeform.options.map((val) => {
            val.dimension.map((val1) => {
                cdeArray.push({
                    "is_active": true,
                    "dimension": val1.name,

                    "data_asset_id": val.data_asset_id,
                    "dataframe_id": val.dataframe_id,
                    "check_name": val1.check_name,
                    "data_attribute_id": val.attribute_id,
                    "rule_name": val1.ruleName,
                    "rule_description": val1.rule_description,
                    "valid_values": val1.expression,
                    // "drift_percentage": 0,
                    // "drift_window_in_day": 0,
                    // "threshold": 0,
                    // "threshold_type": "string",
                    created_by: localStorage.getItem("userName"),
                    "last_modified_by": localStorage.getItem("userName"),
                    "end_date": val.end_date
                })
            })
        })
        axiosInstance.post(`${endpoint}${process.env.REACT_APP_GET_ATTRIBUTE_BULK_API}`,
            {
                "rules": cdeArray
            }
            // {
            //     "data_asset_id": cdeArray[0].data_asset_id,
            //     "dataframe_id": cdeArray[0].dataframe_id,
            //     "check_id": cdeArray[0].check_id,
            //     "data_attribute_id": cdeArray[0].data_attribute_id,
            //     "rule_name": cdeArray[0].rule_name,
            //     "rule_description": cdeArray[0].rule_description,
            //     "dimension": cdeArray[0].dimension_name,
            //     "is_active": cdeArray[0].is_active,
            //     "created_by": cdeArray[0].created_by,
            //     "last_modified_by": cdeArray[0].last_modified_by,
            //     "end_date": cdeArray[0].end_date
            // }
        )
            .then(response => {
                // Handle success

                if (response.data.status === "success") {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "recommendateRule",
                            data: response.data.message,
                            status: "success",

                        },
                    })

                } else {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "recommendateRule",
                            data: response.data.message,
                            status: response.data.status,

                        },
                    })
                }
                dispatch({
                    type: SET_FORM_OPTION,
                    payload: {
                        // TO DO: not sure about this
                        formField: "ruleRecommendationform",
                        data: []
                    }
                })
            })
            .catch(error => {
                // Handle error
                dispatch({
                    type: SET_API_DATA,
                    payload: {
                        apiField: "recommendateRule",
                        data: [],
                        status: "error",
                        message: "Process interrupt due to some technical issue."
                    },
                })
                console.error('Error:', error);
            });
    };
}
export const submitConfigureDQRule = (assetId) => {
    return async (dispatch, getState, { endpoint }) => {
        const { dataAsset: { formData } } = getState();

        dispatch({
            type: LOAD_API_DATA,
            payload: { apiField: "submitCongifureRule" },
        });
        let columnLevelArray = []
        formData.configureColumnDQRuleform.options.map((val) => {
            columnLevelArray.push({
                "attribute_rule_id": val.id,
                "rule_description": val.rule_description,
                "threshold": val.threshold_value,
                "threshold_type": val.threshold_type,
                "is_active": val.is_active,
                last_modified_by: localStorage.getItem("userName"),
                created_by: localStorage.getItem("userName"),
            })

        })
        axiosInstance.patch(`${endpoint}${process.env.REACT_APP_CONFIGURE_BULK_API}`,
            {
                "updates": columnLevelArray
            }
        )
            .then(response => {
                // Handle success

                if (response.data.status === "success") {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "submitCongifureRule",
                            data: response.data.message,
                            status: "success",

                        },
                    })
                    dispatch(getConfigureDQColumnRule(assetId))
                } else {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "submitCongifureRule",
                            data: response.data.message,
                            status: response.data.status,

                        },
                    })
                }

            })
            .catch(error => {
                // Handle error
                dispatch({
                    type: SET_API_DATA,
                    payload: {
                        apiField: "submitCongifureRule",
                        data: [],
                        status: "error",
                        message: "Process interrupt due to some technical issue."
                    },
                })
                console.error('Error:', error);
            });
    };
}
export const editAssetLevelRule = (ruleId, assetId, rule_description, threshold, threshold_type, is_active, driftValue, driftWindow,drift_type,driftPercentage,expression) => {
    return async (dispatch, getState, { endpoint }) => {
        dispatch({
            type: LOAD_API_DATA,
            payload: { apiField: "configureAssetDQRule" },
        });
        axiosInstance.put(`${endpoint}${process.env.REACT_APP_CONFIGURE_ASSET_RULE}/${ruleId}`,

            {
                "rule_description": rule_description,
                "rule_details": {
                    // "drift": drift,
                    "drift_window": driftWindow,
                    "threshold": threshold,
                    "threshold_type": threshold_type,
                    "drift_type":drift_type,
                    "drift_value":drift_type==='Percentage'?driftPercentage:driftValue
                },
                "is_active": is_active,
                "sql_query":expression,
                "last_modified_by": localStorage.getItem("userId"),
                "last_modified": new Date()
                
            }
            // "rule_description": rule_description,
            // "threshold": threshold,
            // "threshold_type": threshold_type,
            // "is_active": is_active
        )
            .then(response => {
                // Handle success

                if (response.data.status === "success") {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "configureAssetDQRule",
                            data: response.data.message,
                            status: "success",

                        },
                    })

                } else {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "configureAssetDQRule",
                            data: response.data.message,
                            status: response.data.status,

                        },
                    })
                }
                dispatch({
                    type: RESET_FORM_VALUE
                })
                dispatch(getConfigureDQAssetRule(assetId))
            })
            .catch(error => {
                // Handle error
                dispatch({
                    type: SET_API_DATA,
                    payload: {
                        apiField: "configureColumnDQRule",
                        data: [],
                        status: "error",
                        message: "Process interrupt due to some technical issue."
                    },
                })
                console.error('Error:', error);
            });

    };
};

export const reuploadFile = (assetName) => {
    return async (dispatch, getState, { endpoint }) => {
        const { dataAsset: { apiData, formData } } = getState();
        const APIformData = new FormData();
        if (formData.filePickUp.value === "Local") {
            APIformData.append('file', formData.selectedFile.value);
        } else if (formData.filePickUp.value === "ADLS") {
            APIformData.append('file_path', `${apiData.adlsDirectory.data.adls_directory_path}/${formData.adlsDirectoryForm.value}/${formData.adlsFileName.value}`);
            APIformData.append('adls_account_name', formData.adlsList.value);
        }
        APIformData.append('domain', apiData.assetSummary.data.domain);
        APIformData.append('sub_domain', apiData.assetSummary.data.sub_domain);
        axiosInstance.put(`${endpoint}${process.env.REACT_APP_GET_ASSETS}${assetName}/replace-file/`, APIformData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                // Add any other custom headers as needed
            },


        })
            .then(response => {
                dispatch(rundataAssetProfiler(apiData.assetSummary.data.data_asset_id))
                let tempArray = JSON.parse(sessionStorage.getItem('bellNotification'));
                tempArray.push(response.data.message)
                sessionStorage.setItem('bellNotification', JSON.stringify(tempArray));
                dispatch({
                    type:SET_NOTIFICATION_ARRAY,
                    payload:{
                        value:tempArray
                    }
                })
            })
            .catch(error => {
                // Handle error

                console.error('Error:', error);
            });

    };
};

                
export const editColumnLevelRule = (ruleId, assetId, rule_description, threshold, threshold_type, is_active,drift_value,drift_type,expression,check_expression) => {
    return async (dispatch, getState, { endpoint }) => {
        dispatch({
            type: LOAD_API_DATA,
            payload: { apiField: "configureColumnDQRule" },
        });
        axiosInstance.put(`${endpoint}${process.env.REACT_APP_ATTRIBUTE_RULE}/${ruleId}`,
            {
                "check_expression": check_expression,
                "expression": expression,
                "drift_type": drift_type,
                "drift_value": drift_value,
                "rule_description": rule_description,
                "threshold": threshold,
                "threshold_type": threshold_type,
                "is_active": is_active,
                "last_modified": new Date(),
                "last_modified_by": localStorage.getItem("userId")
            })
            .then(response => {
                // Handle success

                if (response.data.status === "success") {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "configureColumnDQRule",
                            data: response.data.message,
                            status: "success",

                        },
                    })

                } else {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "configureColumnDQRule",
                            data: response.data.message,
                            status: response.data.status,

                        },
                    })
                }
                dispatch(getConfigureDQColumnRule(assetId))
            })
            .catch(error => {
                // Handle error
                dispatch({
                    type: SET_API_DATA,
                    payload: {
                        apiField: "configureColumnDQRule",
                        data: [],
                        status: "error",
                        message: "Process interrupt due to some technical issue."
                    },
                })
                console.error('Error:', error);
            });

    };
};

export const rundataAssetProfiler = (assetId) => {
    return async (dispatch, getState, { endpoint }) => {
        dispatch({
            type: LOAD_API_DATA,
            payload: { apiField: "runProfiler" },
        });
        axiosInstance.post(`${endpoint}${process.env.REACT_APP_API_RUN_PROFILING}${assetId}/1`)
            .then(response => {
                // Handle success
                let tempArray = JSON.parse(sessionStorage.getItem('bellNotification'));
                tempArray.push(response.data.message)
                sessionStorage.setItem('bellNotification', JSON.stringify(tempArray));
                dispatch({
                    type:SET_NOTIFICATION_ARRAY,
                    payload:{
                        value:tempArray
                    }
                })
                if (response.data.status === "success") {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "runProfiler",
                            data: response.data.message,
                            status: "success",

                        },
                    })
                    dispatch(getdataAssetProfile(assetId))
                } else {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "runProfiler",
                            data: response.data.message,
                            status: response.data.status,

                        },
                    })
                }
            })
            .catch(error => {
                // Handle error
                dispatch({
                    type: SET_API_DATA,
                    payload: {
                        apiField: "runProfiler",
                        data: [],
                        status: "error",
                        message: "Process interrupt due to some technical issue."
                    },
                })
                console.error('Error:', error);
            });
    };
};
export const submitRuleRecommendation = (dataAssetId, showLoadingMessage, show) => {
    return async (dispatch, getState, { endpoint }) => {
        const { dataAsset: { formData, apiData } } = getState();
        dispatch({
            type: LOAD_API_DATA,
            payload: { apiField: "recommendateRule" },
        });
        if (showLoadingMessage !== undefined) {
            let tempArray = JSON.parse(sessionStorage.getItem('bellNotification'));
            tempArray.push("Please be patient; the rule suggestion process may take 5-6 minutes to complete.")
            sessionStorage.setItem('bellNotification', JSON.stringify(tempArray));
            dispatch({
                type:SET_NOTIFICATION_ARRAY,
                payload:{
                    value:tempArray
                }
            })
            showLoadingMessage()
        }
        axiosInstance.post(`${endpoint}${process.env.REACT_APP_API_RULE_RECOMMEND}`, {
            // params: {
            domain_name: apiData.assetSummary.data.domain,
            sub_domain_name: apiData.assetSummary.data.sub_domain,
            asset_id: dataAssetId,
            product_name: formData.selectedProfile.options[0].product_name,
            asset_name: formData.selectedProfile.options[0].data_asset_name,
            fetch_logs: true,
            selected_cdes: formData.selectedProfile.options.map((val) => {
                return {
                    attribute_id: val.attribute_id,
                    attribute_name: val.attribute_name,
                    attribute_details: {
                        data_type: val.attribute_details.statistics.data_type,
                        mean: val.attribute_details.statistics.mean,
                        min: val.attribute_details.statistics.min,
                        max: val.attribute_details.statistics.max,
                        std_dev: val.attribute_details.statistics.std_dev,
                        null_percentage: val.attribute_details.statistics.null_percentage,
                        unique_count: val.attribute_details.statistics.unique_count,
                        total_count: val.attribute_details.statistics.total_count
                    }
                }
            })

        })
            .then(response => {
                // Handle success

                if (response.data.status === "success") {
                    let tempArray = JSON.parse(sessionStorage.getItem('bellNotification'));
                    tempArray.push(response.data.message)
                    sessionStorage.setItem('bellNotification', JSON.stringify(tempArray));
                    dispatch({
                        type:SET_NOTIFICATION_ARRAY,
                        payload:{
                            value:tempArray
                        }
                    })
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "recommendateRule",
                            data: response.data.message,
                            status: "success",

                        },
                    })
                    dispatch({
                        type: SET_FORM_OPTION,
                        payload: {
                            formField: "selectedProfile",
                            data: []
                        }
                    })
                } else {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "runProfiler",
                            data: response.data.message,
                            status: response.data.status,

                        },
                    })
                }
                if (show !== undefined) {
                    show(response.data.status, response.data.message)

                }
                dispatch(ruleRecommendation(dataAssetId))
                dispatch({
                    type: SET_FORM_OPTION,
                    payload: {
                        formField: "selectedProfile",
                        data: []
                    }
                })
                let tempArray = JSON.parse(sessionStorage.getItem('bellNotification'));
                tempArray.push(response.data.message)
                sessionStorage.setItem('bellNotification', JSON.stringify(tempArray));
                dispatch({
                    type:SET_NOTIFICATION_ARRAY,
                    payload:{
                        value:tempArray
                    }
                })
            })
            .catch(error => {
                // Handle error
                dispatch({
                    type: SET_API_DATA,
                    payload: {
                        apiField: "recommendateRule",
                        data: [],
                        status: "error",
                        message: "Process interrupt due to some technical issue."
                    },
                })
                console.error('Error:', error);
            });
    }
}
export const submitSelectedRuleRecommendation = () => {
    return async (dispatch, getState, { endpoint }) => {
        const { dataAsset: { formData, apiData } } = getState();
        dispatch({
            type: LOAD_API_DATA,
            payload: { apiField: "recommendateRule" },
        });
        axiosInstance.post(`${endpoint}${process.env.REACT_APP_SUBMIT_SELECTED_RECOMMENDATION}`, {
            // params: {

            "data_asset_id": apiData.assetSummary.data.data_asset_id,
            selectedrecommendation: formData.selectedRules.options.map((val) => {
                return ({
                    "dataframe_id": val.dataframe_id,
                    "data_attribute_id": val.attribute_id,
                    "rule_name": val.rule_name,
                    "rule_description": val.rule_description,
                    "check_name": val.check_name,
                    "is_active": val.is_active,
                    "created_date": val.created_date,
                    "created_by": val.created_by,
                    "last_modified_by": localStorage.getItem("userName"),
                    "end_date": val.end_date
                })
            })


        })
            .then(response => {
                // Handle success

                if (response.data.status === "success") {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "recommendateRule",
                            data: response.data.message,
                            status: "success",

                        },
                    })

                } else {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "runProfiler",
                            data: response.data.message,
                            status: response.data.status,

                        },
                    })
                }
            })
            .catch(error => {
                // Handle error
                dispatch({
                    type: SET_API_DATA,
                    payload: {
                        apiField: "recommendateRule",
                        data: [],
                        status: "error",
                        message: "Process interrupt due to some technical issue."
                    },
                })
                dispatch(ruleRecommendation(formData.selectedProfile.options[0].data_asset_id))
                console.error('Error:', error);
            });
    }
}

export const getDimension = () => {
    return async (dispatch, getState, { endpoint }) => {
        axiosInstance.get(`${endpoint}${process.env.REACT_APP_DIMENSION}`)
            .then(response => {
                // Handle success
                if (response.data.status === "success") {
                    dispatch({
                        type: SET_DIMENSIONS,
                        payload: {
                            apiField: "dimensions",
                            data: response.data.dimensions,
                            status: "success",
                        },
                    })
                } else {
                    dispatch({
                        type: SET_DIMENSIONS,
                        payload: {
                            apiField: "dimensions",
                            data: [],
                            status: response.data.status,
                        },
                    })
                }
            })
            .catch(error => {
                // Handle error
                console.error('Error:', error);
                dispatch({
                    type: SET_DIMENSIONS,
                    payload: {
                        apiField: "dimension",
                        data: [],
                        status: "fail",
                    },
                })
            });
    };
}
export const saveDimensionsWeightage = (assetId, payload) => {
    return async (dispatch, getState, { endpoint }) => {
        axiosInstance.put(`${endpoint}${process.env.REACT_APP_GET_ASSETS}${assetId}/weightage`,

            {
                "weightage": payload,
                "last_modified_by": localStorage.getItem("userName")
            }
        )
            .then(response => {
                let tempArray = JSON.parse(sessionStorage.getItem('bellNotification'));
                tempArray.push(response.data.message)
                sessionStorage.setItem('bellNotification', JSON.stringify(tempArray));
                dispatch({
                    type:SET_NOTIFICATION_ARRAY,
                    payload:{
                        value:tempArray
                    }
                })
                // Handle success
                if (response.data.status === "success") {
                    dispatch({
                        type: SET_DIMENSIONS_DATA,
                        payload: {
                            apiField: "dimensionsData",
                            data: response.data.message,
                            status: "success",
                        },
                    })
                    dispatch(getDimensionsWeightage(assetId))
                } else {
                    dispatch({
                        type: SET_DIMENSIONS_DATA,
                        payload: {
                            apiField: "dimensionsData",
                            data: response.data.message,
                            status: response.data.status,

                        },
                    })
                }
            })
            .catch(error => {
                // Handle error
                dispatch({
                    type: SET_DIMENSIONS_DATA,
                    payload: {
                        apiField: "dimensionsData",
                        data: [],
                        status: "error",
                        message: "Process interrupt due to some technical issue."
                    },
                })
                console.error('Error:', error);
            });

    };
};

export const getDimensionsWeightage = (assetId) => {
    return async (dispatch, getState, { endpoint }) => {
        const { dataAsset: { apiData } } = getState();
        dispatch({
            type: LOAD_API_DATA,
            payload: { apiField: "dimensionWeightage" },
        });
        axiosInstance.get(`${endpoint}${process.env.REACT_APP_GET_ASSET}${assetId}/weightage`)
            .then(response => {
                // Handle success
                if (response.data.status === "success") {

                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "dimensionWeightage",
                            data: response.data.weightage,
                            status: "success",
                        },
                    })
                    dispatch({
                        type: SET_FORM_OPTION,
                        payload: {
                            formField: "dimensionWeightageForm",
                            data: response.data.weightage,
                            status: "success",
                        },
                    })

                } else {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "dimensionWeightage",
                            data: [],
                            status: response.data.status,
                        },
                    })
                }
            })
            .catch(error => {
                // Handle error
                dispatch({
                    type: SET_API_DATA,
                    payload: {
                        apiField: "dimensionWeightage",
                        data: [],
                        status: "error",
                        message: "Process interrupt due to some technical issue."
                    },
                })
                console.error('Error:', error);
            });

    };
};
